import React from "react";
import * as ReactDOM from "react-dom";
import {Trans, useTranslation} from "react-i18next";
import {RegistrationVoucher} from "../../helpers/registrationVoucher";

// Footer footnote for newsletter registration voucher conditions
const NewsletterRegistrationFootnote: React.FC = () => {
  const {t} = useTranslation();
  const footerClass = document.body.getElementsByClassName("voucher-footnote")[0];

  if (footerClass && RegistrationVoucher.enabled) {
    return ReactDOM.createPortal(
      <React.Fragment>
        <span className="footnote">
          <sup className="footnote-icon">1</sup>
          <span>
            {t("newsletter.voucherValidityConditions", {
              count: RegistrationVoucher.minOrderValue ?? 0,
              minOrderValue: RegistrationVoucher.minOrderValueFormatted,
            })}{" "}
            <Trans
              i18nKey="newsletter.voucherConditionsApply"
              ns="translations"
              components={{a: <a href={t("url.voucherActionsLink")} target="_blank" rel="noreferrer" />}}
            />
          </span>
        </span>
      </React.Fragment>,
      footerClass,
    );
  } else {
    return null;
  }
};

export default NewsletterRegistrationFootnote;
